import api from "services/api";

/**
 * Get or create a direct (1-on-1) conversation with another user
 * @param {Object} recipientData - { recipientId, recipientName, recipientAvatar, recipientRole }
 */
export const getOrCreateDirectConversation = async (recipientData) => {
  return api.post("/v1/api/chat/conversations/direct", recipientData);
};

/**
 * Create a group conversation
 * @param {Object} groupData - { name, avatar, participants }
 */
export const createGroupConversation = async (groupData) => {
  return api.post("/v1/api/chat/conversations/group", groupData);
};

/**
 * Fetch all conversations for the logged in user
 */
export const getUserConversations = async () => {
  return api.get("/v1/api/chat/conversations");
};

/**
 * Send a chat message into a conversation
 * @param {Object} messageData - { conversationId, text, messageType, attachments }
 */
export const sendChatMessage = async (messageData) => {
  return api.post("/v1/api/chat/messages", messageData);
};

/**
 * Fetch messages for a specific conversation with optional pagination
 * @param {string} conversationId
 * @param {Object} params - { page, limit }
 */
export const getConversationMessages = async (conversationId, params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const url = `/v1/api/chat/conversations/${conversationId}/messages${queryParams ? `?${queryParams}` : ""}`;
  return api.get(url);
};

/**
 * Mark messages in a conversation as read
 * @param {string} conversationId
 */
export const markConversationAsRead = async (conversationId) => {
  return api.post(`/v1/api/chat/conversations/${conversationId}/read`, {});
};
